import React from 'react'

const Petunjuk = () => {
    return (
        <div className="container-fluid">
            <div className="card border-success shadow  bg-body rounded ">
            <div style={{backgroundColor:'#339966'}} className="card-header text-center text-white">
                <h4>Petunjuk Kuis</h4>
            </div>
            <div className="card-body text-black" style={{backgroundColor:'#ecf9f2', textAlign: "justify",
										lineHeight: "35px",}}>
                <ol className="card-tittle">
                <li>Tekan tombol mulai di bawah</li>
                    <li>Silahkan lengkapi data diri pada form yang disediakan</li>
                    <li>Kuis terdiri dari 10 soal pilihan ganda.</li>
                    <li>Tekan <strong>"Mulai Kuis"</strong> jika Anda sudah melengkapi data diri.</li>
                    <li>Pilih satu jawaban yang dianggap benar.</li>
                    <li>Setelah semua pertanyaan selesai dijawab, tekan tombol "Selesai" maka hasil kuis akan muncul.</li>
                </ol>
            </div>
            </div>
        </div>
    )
}

export default Petunjuk